import React from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  className?: string;
  fill?: string;
}

const GoBack: React.FC<Props> = ({ className, fill }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const newClassName = className
    ? `${className}`
    : "w-full flex justify-start items-center px-10";

  return (
    <div className={newClassName}>
      <svg
        onClick={handleGoBack}
        className="cursor-pointer"
        width="16"
        height="26"
        viewBox="0 0 16 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 2L3 14L13.5 24"
          stroke={fill ? fill : "#202A43"}
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export default GoBack;
